import { Injector } from '@angular/core';
import { draggableNodeStopEvent } from '@examdojo/core/tiptap';
import { mergeAttributes, Node } from '@tiptap/core';
import { AngularNodeViewRenderer } from 'ngx-tiptap';
import { parseJsonAttr } from '../parse-json-attr.util';
import { SolverNodeComponent } from './solver.component';
import { DEFAULT_SOLVER_PROPS } from './solver.model';

const solverClassName = 'solver';
const slidesDataAttr = 'data-slides';
const contentDataAttr = 'data-content';

export const SolverExtension = (injector: Injector) => {
  return Node.create({
    name: 'solver',
    group: 'block',
    atom: true,
    selectable: true,
    draggable: true,

    addAttributes() {
      return {
        name: {
          default: null,
        },
        content: {
          default: null,
          renderHTML: (attributes) => {
            return {
              [contentDataAttr]: JSON.stringify(attributes['content'] ?? null),
            };
          },
          parseHTML: (element) => parseJsonAttr(element, contentDataAttr, null),
        },
        slides: {
          default: DEFAULT_SOLVER_PROPS.slides,
          renderHTML: (attributes) => {
            return {
              [slidesDataAttr]: JSON.stringify(attributes['slides'] ?? DEFAULT_SOLVER_PROPS.slides),
            };
          },
          parseHTML: (element) => parseJsonAttr(element, slidesDataAttr, DEFAULT_SOLVER_PROPS.slides),
        },
        class: {
          renderHTML: (attributes) => {
            const otherClasses = ((attributes['class'] ?? '') as string)
              .split(' ')
              .filter((c) => c !== solverClassName);
            return { class: `${solverClassName} ${otherClasses.join(' ')}` };
          },
        },
      };
    },

    parseHTML() {
      return [
        {
          tag: `div.${solverClassName}`,
        },
      ];
    },

    renderHTML({ HTMLAttributes }) {
      return ['div', mergeAttributes({ class: solverClassName }, HTMLAttributes)];
    },

    addNodeView() {
      return AngularNodeViewRenderer(SolverNodeComponent, {
        injector,
        stopEvent: draggableNodeStopEvent,
      });
    },
  });
};
